import { Paper, Table, TableBody, TableContainer } from "@mui/material";

import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import { SETTLEMENT_STYLES } from "../../style/styles";

import SettlementPaymentsListItem from "./SettlementPaymentsListItem";
import SettlementPaymentsTableHeader from "./SettlementPaymentsTableHeader";

export default function SettlementPaymentsTable({
  data = [],
  isLoading,
  paymentTypeDisplayMap,
  onEdit,
  canEdit = false,
}) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data.length) {
    return (
      <div className="flex min-h-0 flex-1">
        <div
          className="flex h-full min-h-[220px] w-full flex-1 items-center justify-center rounded-[12px] px-6 py-5 text-center text-base font-semibold"
          style={SETTLEMENT_STYLES.emptyStateCard}
        >
          Nothing To Show
        </div>
      </div>
    );
  }

  return (
    <TableContainer component={Paper} sx={SETTLEMENT_STYLES.scrollbarSx}>
      <Table stickyHeader aria-label="settlement payments collapsible table">
        <SettlementPaymentsTableHeader showActions={canEdit} />
        <TableBody>
          {data.map((payment) => (
            <SettlementPaymentsListItem
              key={payment.id}
              data={payment}
              paymentTypeDisplayMap={paymentTypeDisplayMap}
              onEdit={onEdit}
              canEdit={canEdit}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
